import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import sha1 from 'crypto-js/sha1';

import { environment } from '@app/environment';

@Injectable({
  providedIn: 'root'
})
export class CloudinaryService {
    
    constructor(
        private httpClient: HttpClient
    ) { }
    
    async getSignature(timestamp: number, folder: string): Promise<string|null> {
        
        return new Promise ((resolve) => {
            
            let signature: string|null = null;
           
            let options: any = {
                headers: {
                    'Content-Type': ''
                },
                withCredentials: false,
                responseTypes: 'json',
                params: {
                    timestamp: timestamp,
                    folder: folder
                }
            };

            this.httpClient.post(environment.URL_API_BACKEND_REST + 'cloudinary/signature', null, options).subscribe(
                (response: any) => {                    
                    resolve((response.signature ? response.signature : null));
                },
                (error) => {
                    resolve(null);
                }
            );
        });
        
    }
    
    async uploadFile(file: File, folder: string, typeFile: 'image'|'video'|'auto' = 'auto', withSignature: boolean = true): Promise<string|null> {
        
        let pictureUrl: string|null = null;
        const timestamp = Math.round(Date.now() / 1000);
        const signature = await this.getSignature(timestamp, folder);
        
        if(signature){
            const uploadId = window.crypto.randomUUID();
            const maxSize = 99 * 1024 * 1024; // 99Mo
            let offset = 0;
            const fileSize = file.size;
            while (offset < fileSize) {
                let newOffset = Math.min(offset+maxSize, fileSize);     
                let chunk = file.slice(offset,newOffset);  
                let contentRange = 'bytes '+offset+'-'+(newOffset-1)+'/'+fileSize;
                pictureUrl = await this.uploadData(chunk, folder, timestamp, signature, typeFile, uploadId, contentRange);
                offset = newOffset;
            }            
        }
        
        return pictureUrl;
    }
    
    async uploadBlob(blob: Blob, folder: string, typeFile: 'image'|'video'|'auto' = 'auto', withSignature: boolean = true): Promise<string|null> {
        
        let pictureUrl: string|null = null;
        const timestamp = Math.round(Date.now() / 1000);
        const signature = await this.getSignature(timestamp, folder);
                
        if(signature){
            const maxSize = 59 * 1024 * 1024; // 59Mo
            let base64 = await this.blobToBase64(blob);
            if(base64){
                pictureUrl = await this.uploadData(base64, folder, timestamp, signature);
            }        
        }
        
        return pictureUrl;
    }
    
    private blobToBase64(blob: Blob): Promise<any>{
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }
    
    private async uploadData(dataFile: any, folder: string, timestamp: number, signature: string, typeFile: 'image'|'video'|'auto' = 'auto', uploadId?: string, contentRange?: string): Promise<string|null>{
        return new Promise ((resolve) => {
            
            let options: any = {                
                withCredentials: false,
                responseTypes: 'json',
                headers: {}
            };
            
            if(uploadId && contentRange){
                options.headers['X-Unique-Upload-Id'] = uploadId;
                options.headers['Content-Range'] = contentRange;
            }
            
            let formData = new FormData();
            formData.append('timestamp', timestamp.toString());
            formData.append('signature', signature);
            formData.append('folder', folder);
            formData.append('api_key', environment.CLOUDINARY.API_KEY);
            formData.append('resource_type', typeFile);
            formData.append("file", dataFile);
            
            let pathUpload = (typeFile === 'image' ? environment.CLOUDINARY.UPLOAD_PATH_IMAGE : (typeFile === 'video' ? environment.CLOUDINARY.UPLOAD_PATH_VIDEO : environment.CLOUDINARY.UPLOAD_PATH_AUTO));
            
            this.httpClient.post(environment.CLOUDINARY.BASE_URL + environment.CLOUDINARY.CLOUD_NAME + pathUpload, formData, options).subscribe(
                (response: any) => {
                    resolve((response?.secure_url ? response.secure_url : null));
                },
                (error) => {
                    resolve(null);
                }
            );
        });
    }
}

